import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, urlsData } from "@/data";
import { getGroupQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetGroup = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { data, error, loading } = useQuery(getGroupQuery, {
        skip: !isAuthenticated || !id,
        variables: {
            where: { id },
        },
    });

    useEffect(
        () => {
            if (!loading && data && !data.driveGroup) navigate(urlsData.routes.notFound);
        },
        [data, loading], // eslint-disable-line
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.driveGroup,
        loading,
    };
};

export default useGetGroup;
